import { AriaRole } from 'react';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

import { HintType } from './hint.types';

const getHintIcon = (type?: HintType) => {
  switch (type) {
    case 'error':
      return getDesignSystemIcon('icon-error-inverted.svg');
    case 'warn':
      return getDesignSystemIcon('icon-exclamationmark-inverted.svg');
    case 'success':
      return getDesignSystemIcon('icon-checkbox-inverted.svg');
    case 'info':
      return getDesignSystemIcon('icon-circle-info.svg');
  }
};

const getHintColor = (type?: HintType) => {
  switch (type) {
    case 'error':
      return 'text-red';
    case 'warn':
      return 'text-yellow';
    case 'success':
      return 'text-green';
    case 'info':
      return 'text-secondary';
  }
};

const getHintRole = (type?: HintType): Extract<AriaRole, 'alert' | 'status'> => {
  switch (type) {
    case 'error':
    case 'warn':
      return 'alert';
    default:
      return 'status';
  }
};

const getHintBorderColor = (type?: HintType) => {
  switch (type) {
    case 'error':
      return '!border-red !outline-red !outline-1 !outline';
    case 'warn':
      return '!border-yellow !outline-yellow !outline-1 !outline';
    case 'success':
      return '!border-green !outline-green !outline-1 !outline';
    case 'info':
      return '!border-secondary !outline-secondary !outline-1 !outline';
  }
};

export { getHintIcon, getHintColor, getHintBorderColor, getHintRole };
